module.exports = __webpack_public_path__ + "images/emoji/racehorse.94285c9af37855ae426e.png";